<div class="grid-container margin-top">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold red italic">
      @if (allowDeactivate?.value == false) {
        You have unsaved changes.  Please use the "Save Update" button before exiting the page, or your changes will be lost.
      }
    </div>
    <div class="cell large-12 medium-12 small-12">
      <ag-grid-angular class="data-grid  full-page" [gridOptions]="gridOptions" [rowData]="config" [groupDefaultExpanded]="-1" [excelStyles]="excelStyles" [statusBar]="statusBar" aria-label="Manage Fees"></ag-grid-angular>
    </div>
  </div>
</div>
<fee-editor (feesSaved)="saveUpdate($event)"></fee-editor>